import { render, staticRenderFns } from "./TrainerLayout.vue?vue&type=template&id=31bfaa2c&scoped=true"
import script from "./TrainerLayout.vue?vue&type=script&lang=js"
export * from "./TrainerLayout.vue?vue&type=script&lang=js"
import style0 from "./TrainerLayout.vue?vue&type=style&index=0&id=31bfaa2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bfaa2c",
  null
  
)

export default component.exports